import React,{useEffect,useState, useCallback} from "react";
import logoschool from "../../assets/images/logosignup.png";
import logomain from "../../assets/images/logomain.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { SchoolSignupContext } from "../../context/SchoolSignupContext";
import CirculerLoader from "../../components/Loader";
// import { SchoolSignupContext } from './SchoolSignupContext'; // adjust path

import Select from "react-select";
import useThrottledClick from "../../hooks/useThrottledClick";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TrialExpiredModal from "../../components/TrialExpiredModal";
import {
  checkAndBlockIfTrialExpired,
  verifySchoolSubscriptionBlocked,
} from "../../utils/schoolSubscription";
import { useTrialExpiredModal } from "../../hooks/useTrialExpiredModal";


const School =()=>{
    // navigate =useNavigate()
    const { signupData, setSignupData, setSignupDataSession } = React.useContext(SchoolSignupContext);
    const baseURL = process.env.REACT_APP_BASE_URL;
        // const baseURL="http://localhost:8000/api/v1"
    const navigate = useNavigate();
    const [schools, setSchools] = useState([]);
    const [schoolOptions, setSchoolOptions] = useState([]);
    const [verificationCode,setVerificationCode]=useState(signupData?.verificationCode?signupData?.verificationCode:"")

    const [selectedSchool, setSelectedSchool] = useState(signupData?.schoolName?signupData?.schoolName:"");
const [schoolType] = useState(signupData?.schoolType ? signupData?.schoolType : "");
    const [value, setValue] = useState('');
  
    const [loading, setLoading] = useState(true);
    const [, setError] = useState("");
    const searchTerm = ""; // State for search term
  
    const fetchSchools = useCallback(async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${baseURL}/school/users/getAllSchool`,
          {
            params: { 
              schoolName:searchTerm?searchTerm:"",
              masterTypeid:schoolType?schoolType:"",

             },
              // safer way to handle query params
          }
        );
        
        setSchools(response.data.data); // Adjust according to API response format


   
      } catch (err) {
        if (err.response) {
           // Server responded with a status other than 2xx
          toast.error(`Server Error: ${err.response.status} - ${err.response.data.message || err.response.statusText}`);

          setError(`Server Error: ${err.response.status} - ${err.response.data.message || err.response.statusText}`);
        } else if (err.request) {
           // Request was made but no response
          setError("No response from server. Please check your network.");
          toast.error(`No response from server. Please check your network.`);

        } else {
           // Something else happened
          setError(`Error: ${err.message}`);
          toast.error(`Error: ${err.message}`);

        }
      } finally {
        setLoading(false);
      }
    }, [baseURL, schoolType, searchTerm]);
    useEffect(() => {
      fetchSchools();
    }, [fetchSchools]);
  
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageCode, setErrorMessageCode] = useState("");
    const {
      showTrialExpiredModal,
      setShowTrialExpiredModal,
      handleTrialRenew,
      handleTrialCancel,
      cancelLoading,
    } = useTrialExpiredModal(signupData);



    

    const handleChange = (e) => {
      const { name, value } = e.target;

    // If the field should accept digits only
      if (name === "schoolCode" || name === "otp") {
        if (!/^\d*$/.test(value)) return; // Prevent invalid input
        setValue(value);
      }
    
      // Update the form data
        setSignupData((prev) => ({
        ...prev,
        [name]: value,
      }));



      setSignupDataSession((prev) => ({
        ...prev,
        [name]: value,
      }));
    };



    const handleSelectChange = (selectedOption) => {
      setVerificationCode(selectedOption.verificationCode)
      setSelectedSchool(selectedOption.value);
      setSignupData((prev) => ({
        ...prev,
        schoolName: selectedOption.value,
        schoolId: selectedOption.id,
        verificationCode: selectedOption.verificationCode,
      }));

      setSignupDataSession((prev) => ({
        ...prev,
        schoolName: selectedOption.value,
        schoolId: selectedOption.id,
        verificationCode: selectedOption.verificationCode,
      }));
    };

  const handleContinue = async () => {
    await new Promise(res => setTimeout(res, 1000));

    if (!selectedSchool) {
      setErrorMessage("Please select a school.");
      toast.error(`Please select a school.`);

      return;
    }

    if (!value) {

      setErrorMessageCode("Please enter the school code.");
      toast.error(`Please enter the school code.`);

      return;
    }

    if (verificationCode !== value) {
      setErrorMessageCode("Please enter the correct school code.");
      toast.error(`Please enter the correct school code.`);

      return;

    }


    setErrorMessage("");
    setErrorMessageCode("");

    try {
      const schoolId = signupData?.schoolId;
      const verifyResponse = await axios.post(`${baseURL}/school/codeverify`, {
        code: value,
        schoolId,
      });

      if (verifyResponse.data?.code !== 200) {
        setErrorMessageCode(verifyResponse.data?.message || "Invalid school code.");
        toast.error(verifyResponse.data?.message || "Invalid school code.");
        return;
      }

      const schoolContext = {
        schoolId,
        schoolName: selectedSchool,
        schoolCode: value,
        verificationCode: value,
      };

      setSignupData((prev) => ({ ...prev, ...schoolContext }));
      setSignupDataSession((prev) => ({ ...prev, ...schoolContext }));

      const blocked =
        checkAndBlockIfTrialExpired(verifyResponse.data, schoolContext) ||
        (await verifySchoolSubscriptionBlocked(baseURL, schoolContext));
      if (blocked) {
        setShowTrialExpiredModal(true);
        return;
      }

      navigate("/login-page", {
        state: { selectedSchool, value },
      });
    } catch (err) {
      toast.error("Unable to verify school. Please try again.");
    }

  };

    
    useEffect(() => {
      const options = schools.map((school) => ({
        value: school.schoolName,
        label: school.schoolName,
        id:school.id,
        verificationCode:school.schoolCode
      }));
      setSchoolOptions(options);

     if (schools && schools.length > 0) {
        const firstSchool = schools[0];
        const firstCode = firstSchool.schoolCode || firstSchool.verificationCode || "";

        setSelectedSchool(firstSchool.schoolName);
        setVerificationCode(firstCode);

        setSignupData((prev) => ({
          ...prev,
          schoolName: firstSchool.schoolName,
          schoolId: firstSchool.id,
          verificationCode: firstCode,
        }));

        setSignupDataSession((prev) => ({
          ...prev,
          schoolName: firstSchool.schoolName,
          schoolId: firstSchool.id,
          verificationCode: firstCode,
        }));
     }
   }, [schools, setSignupDataSession]); // runs whenever `schools` is updated


    const [throttledContinue, isLoading] = useThrottledClick(handleContinue, 3000);


    return(
    <>
    <TrialExpiredModal
      open={showTrialExpiredModal}
      onActivatePlan={handleTrialRenew}
      onCancelSubscription={handleTrialCancel}
      cancelLoading={cancelLoading}
    />

    <div className="school-pages-inner" style={{position:"relative"}}>
        <div className="school-content-page">
        
             {schoolType === 1 ? <img src={logomain} 
             alt="School Logo"
					style={{ cursor: "pointer" }}
					onClick={() => navigate("/school", { state: { fromLanding: true } })}
             />:       
              <img src={logoschool}
              alt="School Logo"
					style={{ cursor: "pointer" }}
					onClick={() => navigate("/school", { state: { fromLanding: true } })}
              
              /> }    

        <div className="schoo-outer">
            <div className="school-outer-pages">
            <h2>Select Your School</h2>


            <Select
              options={schoolOptions}
              onChange={handleSelectChange}
              value={schoolOptions.find(opt => opt.value === selectedSchool)}
              placeholder="Search and select a school..."
              isSearchable={true}
                id="school-select"
            />
            {errorMessage && (
              <p className="error-message" style={{ color: "red" }}>
                {errorMessage}
              </p>
            )}

            {/* <input
  type="text"
  placeholder="Search school..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>


            <select
            name="schoolName"
             value={selectedSchool} onChange={handleSelect}

             >
          <option value="">-- Select School --</option>
          {schools.map((school, index) => (
            <option key={school.id} value={school.schoolName}>
              {school.schoolName}
            </option>
          ))}
        </select> */}



            <div className="input-container">
                <input type="text"
                  name="schoolCode"
                  value={value}
                  onChange={handleChange}
                  placeholder=" "
                  
			  // placeholder="Search school..."
        //   onChange={(e) => setValue(e.target.value)}
        //   onChange={handleChange}
        //   onBlur={handleBlur}
        //   className={isValid === false ? "invalid" : ""} // Add invalid class if not valid
                />
                <label >Code</label>


            </div>
            {errorMessageCode && (
              <p className="error-message" style={{ color: "red" }}>
                {errorMessageCode}
              </p>
            )}


            <button className="continue-btn" 
             //  onClick={handleContinue}
               onClick={throttledContinue}


            >
              {isLoading ? '⏳ CONTINUING...' : 'CONTINUE'}

                     
                      {/* CONTINUE */}
            </button>
            

            <p className="term-part" >
              <a href="/terms-of-use" >Terms of Use</a>  |  <a href="/privacy-policy" >Privacy Policy</a>
            </p>

            {/* Loader Overlay */}
            {loading && (
              <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              background: "rgba(255,255,255,0.1)", // lighter overlay
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}>
                <CirculerLoader />
              </div>
            )}

            </div>

        </div>

        </div>

    </div>



    </>);

}
export default School;